import styled from 'styled-components';

export default styled.div`
  width: 18px;
  height: 18px;
  border-radius: 3px;
  border: 1px solid #a9a9a9;
  background-color: ${props => (props.color ? `${props.color}` : 'transparent')};
`;
